export const Constant = {
    messageStatus: {
        success: "success",
        info: "info",
        warn: "warn",
        error: "error",
    },
    response: {
        isSuccess: "isSuccess",
        message: "message",
        data: "data",
        exception: "exception",
    },
    auths: {
        isLoginIn: 'crm-loggedIn',
        token: 'crm-token',
        userId: 'crm-userId',
        userName: 'crm-userName',
        currentUser: 'crm-currentUser',
        fullName: 'crm-fullName'
    },
    classes: {
        includes: {
            province: {
                country: "Country",
            },
            district: {
                province: "Province",
            },
            ward: {
                district: "District",
            },
            hub: {
                district: "District",
                ward: "Ward",
                centerHub: "CenterHub",
                poHub: "PoHub",
            },
            user: {
                department: "Department",
                role: "Role",
                hub: "Hub",
            },
            shipment: {
                sender: "Sender",
                service: "Service",
                fromHub: "FromHub",
                toHub: "ToHub",
                fromHubRouting: "FromHubRouting",
                toHubRouting: "ToHubRouting",
                fromWard: "FromWard",
                fromDistrict: "FromWard.District",
                fromProvince: "FromWard.District.Province",
                toWard: "ToWard",
                toDistrict: "ToWard.District",
                toProvince: "ToWard.District.Province",
                shipmentStatus: "ShipmentStatus",
                package: "Package",
                pickUser: "PickUser",
                deliverUser: "DeliverUser",
                transferUser: "TransferUser",
                returnUser: "ReturnUser",
                transferReturnUser: "TransferReturnUser",
                receiveHub: "ReceiveHub",
                currentHub: "CurrentHub",
                currentEmp: "CurrentEmp",
                paymentType: "PaymentType",
                serviceDVGT: "ServiceDVGT",
                weight: "Weight",
            },
            customer: {
                province: "Province",
                district: "District",
                ward: "Ward",
                customerPriceList: "CustomerPriceList",
                hub: "Hub",
                accountingUser: "AccountingUser",
                salesUser: "SalesUser",
                supportUser: "SupportUser",
                paymentType: "PaymentType",
                paymentToCustomer: "PaymentToCustomer"
            },
            serviceDVGTPrice: {
                formula: "Formula",
                serviceDVGT: "ServiceDVGT",
            },
            priceServiceDetail: {
                priceService: "PriceService",
                area: "Area",
                weight: "Weight",
            },
            priceService: {
                priceList: "PriceList",
                service: "Service",
                areaGroup: "AreaGroup",
                weightGroup: "WeightGroup",
            },
            priceList: {
                hub: "Hub"
            },
            weight: {
                formula: "Formula",
                weightGroup: "WeightGroup",
            },
            areaGroup: {
                hub: "Hub",
            },
            area: {
                areaGroup: "AreaGroup",
                province: "Province",
                district: "District",
            },
            customerPriceList: {
                priceList: "PriceList",
            }
        },
    },
    pages: {
        login: {
            name: 'Đăng nhập', 
            alias: 'dang-nhap',
            hidden: true,
        },
        page404: {
            name: 'Không tìm thấy trang',
            alias: '404',
        },
        page403: {
            name: 'Không có quyền truy cập',
            alias: '403',
        },
        changePassWord: {
            name: 'Thay đổi mật khẩu',
            alias: 'thay-doi-mat-khau',
        },
        customer: {
            name: 'Quản lý khách hàng',
            alias: 'quan-ly-khach-hang',
            loadChildren: () => import('../app-secured/customer-management/customer-management.module').then(m => m.CustomerManagementModule),
            children: {
                customer: {
                    name: 'Khách hàng',
                    alias: 'khach-hang',
                },
                customerSetting: {
                    name: 'Cài đặt',
                    alias: 'cai-dat',
                },
                contractPrinciples: {
                    name: 'Quản Lý Hợp Đồng Nguyên Tắc',
                    alias: 'quan-ly-hop-dong-nguyen-tac',
                },
                contract: {
                    name: 'Xem hợp đồng',
                    alias: 'hop-dong/:customerId/:id'
                },
                createContract: {
                    name: 'Tạo hợp đồng',
                    alias: 'hop-dong/:customerId/:id'
                }
            }
        },
        receiver: {
            name: "Quản lý người nhận",
            alias: "quan-ly-nguoi-nhan",
            loadChildren: () => import('../app-secured/customer-info-log-management/customer-info-log-management.module').then(m => m.CustomerInfoLogManagementModule),
            children: {
                invoiceLog: {
                    name: "Danh sách thông tin XHĐ",
                    alias: "danh-sach-thong-tin-xhd",
                },
                listReceiver: {
                    name: "Danh sách người nhận",
                    alias: "danh-sach-nguoi-nhan",
                },
            }
        },
    }
};



// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/infrastructure/constant.ts